import { render, staticRenderFns } from "./RotatingLogo.vue?vue&type=template&id=b0d7c47a&scoped=true&"
import script from "./RotatingLogo.vue?vue&type=script&lang=js&"
export * from "./RotatingLogo.vue?vue&type=script&lang=js&"
import style0 from "./RotatingLogo.vue?vue&type=style&index=0&id=b0d7c47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d7c47a",
  null
  
)

export default component.exports